import { useGlobal } from "../GlobalContext";

/**
 * Shared role-permission check backed by GlobalContext's rolePermissionList.
 *
 * Usage:
 *   const checkPermission = useRolePermission();
 *   checkPermission("Project", "menu_permission");
 *   checkPermission("Project", "create_permission");
 */
export const useRolePermission = () => {
  const { rolePermissionList } = useGlobal();

  // True when the role has the given permission for the named menu.
  const checkPermission = (menuName, permission) =>
    rolePermissionList.some((element) => element.name === menuName && element[permission] === true);

  return checkPermission;
};
